import React, { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';
import {
  CustomCursor,
  TopBar,
  MainNavigation,
  HeroSection,
  TodaysLunchSection,
  HandmadeSection,
  PhilosophySection,
  MenuSection,
  ChefSection,
  ReviewsSection,
  ReservationCTA,
  SisterRestaurantSection,
  MapSection,
  Footer,
} from './home';

// Re-export TopBar and MainNavigation for other pages that import them
export { TopBar, MainNavigation } from './home';

const GucciSunsariHome = () => {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="bg-[#F5F3EF] min-h-screen" style={{ cursor: 'none' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=DM+Serif+Display:ital@0;1&display=swap');
        * { cursor: none !important; }
        body { font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif; }
        @media (max-width: 768px) { * { cursor: auto !important; } }
      `}</style>

      <CustomCursor />
      <TopBar />
      <MainNavigation />
      
      <main>
        <HeroSection />
        <TodaysLunchSection />
        <HandmadeSection />
        <PhilosophySection />
        <MenuSection />
        <ChefSection />
        <ReviewsSection />
        <MapSection />
        <ReservationCTA />
      </main>

      <Footer />
    </div>
  );
};

export default GucciSunsariHome;
